import React, { FC } from 'react';
import styled from 'src/theme';
import { Row, Col } from "antd";
import { Form } from './Form';

interface Props {}

export const Step2: FC<Props> = () => {
  return (
    <RowStyled justify='center' gutter={[0, 40]}>
      <Col flex={'0 0 500px'}>
        <Form />
      </Col>
    </RowStyled>
  );
};

const RowStyled = styled(Row)`
  padding: 25px 10px 40px;
  background: ${props => props.theme.colors.smoke};
  border-radius: 6px;
`;
